import '../../../../common-assets/js/external/jquery.ui.touch-punch.min';
import { sliderOptionFormat } from '../../../../common-assets/js/components/search/search_slider_format';

export const searchMileageSlider = {
    sliderName: '',
    fromElement: '',
    toElement: '',
    minimumValue: 0,
    maximumValue: 600000,
    sliderOptionsCount: 0,
    sliderStepWidth: 0,
    sliderMaximum: 490, // keep this value multiply of length of list, i.e. this.sliderOptionsCount * 10
    list: [],
    generateList() {
        this.list = [
            this.minimumValue,
            1,
            5000,
            10000,
            15000,
            20000,
            25000,
            30000,
            35000,
            40000,
            45000,
            50000,
            55000,
            60000,
            65000,
            70000,
            75000,
            80000,
            85000,
            90000,
            95000,
            100000,
            105000,
            115000,
            125000,
            135000,
            145000,
            155000,
            165000,
            175000,
            185000,
            195000,
            205000,
            215000,
            225000,
            235000,
            245000,
            255000,
            265000,
            275000,
            285000,
            295000,
            320000,
            350000,
            400000,
            450000,
            500000,
            550000,
            this.maximumValue,
        ];
        this.sliderOptionsCount = this.list.length;
        this.sliderStepWidth = this.sliderMaximum / this.sliderOptionsCount;
    },
    init(options = {}) {
        this.sliderName = options.sliderName ? options.sliderName : $('#simple_search #mileageSlider');
        this.fromElement = options.fromElement ? options.fromElement : $('#simple_search #kilometersFrom');
        this.toElement = options.toElement ? options.toElement : $('#simple_search #kilometersTo');
        this.generateList();

        this.sliderName.slider({
            animate: true,
            range: true,
            min: 0,
            max: this.sliderMaximum,
            create() {
                searchMileageSlider.setSlider(
                    searchMileageSlider.fromElement.val(),
                    searchMileageSlider.toElement.val()
                );
                searchMileageSlider.sliderFormat();
            },
            slide(event, ui) {
                if (ui.handle.nextSibling) {
                    let minValIndex = sliderOptionFormat.getSliderIndex(
                        ui.values[0],
                        searchMileageSlider.sliderOptionsCount,
                        searchMileageSlider.sliderStepWidth
                    );
                    searchMileageSlider.fromElement.val(searchMileageSlider.list[minValIndex]);
                } else {
                    let maxValIndex = sliderOptionFormat.getSliderIndex(
                        ui.values[1],
                        searchMileageSlider.sliderOptionsCount,
                        searchMileageSlider.sliderStepWidth
                    );
                    searchMileageSlider.toElement.val(searchMileageSlider.list[maxValIndex]);
                }
                searchMileageSlider.sliderFormat();
            },
            stop() {
                searchMileageSlider.fromElement.trigger('change');
            },
        });

        // Disable tabbing on slider handles
        this.sliderName.find('.ui-slider-handle').attr('tabindex', '-1');
    },
    setSlider(fromValue, toValue) {
        let fromIndex = 0,
            toIndex = searchMileageSlider.sliderMaximum;

        let parsedFromValue = parseInt(fromValue, 10);
        let parsedToValue = parseInt(toValue, 10);
        if (parsedFromValue > 0) {
            parsedFromValue = sliderOptionFormat.getClosestOption(searchMileageSlider.list, parsedFromValue);
            fromIndex =
                $.inArray(parseInt(parsedFromValue, 10), searchMileageSlider.list) *
                searchMileageSlider.sliderStepWidth;
        }

        if (parsedToValue > 0) {
            parsedToValue = sliderOptionFormat.getClosestOption(searchMileageSlider.list, parsedToValue);
            toIndex =
                $.inArray(parseInt(parsedToValue, 10), searchMileageSlider.list) * searchMileageSlider.sliderStepWidth;
        }

        searchMileageSlider.sliderName.slider('values', [fromIndex, toIndex]);
    },
    sliderFormat() {
        sliderOptionFormat.setRangeSlider(
            searchMileageSlider.fromElement,
            searchMileageSlider.toElement,
            searchMileageSlider.minimumValue,
            searchMileageSlider.maximumValue,
            'mileageRange',
            'km',
            true
        );
    },
};
